<div class="sign-selector-background">
  <div class="ip-board-form-title">
    <div class="form-title-text">{{ title || 'Kies een bord' }}</div>
  </div>
  <div *ngIf="!init" class="spinner-container">
    <mat-spinner color="primary" diameter="75"></mat-spinner>
  </div>
  <div class="form-section-padding" *ngIf="init">
    <div
      class="sign-option-container"
      [ngClass]="
        project.collaborative ? 'collaborative-sign-option-container' : ''
      "
    >
      <ng-container *ngIf="!project.collaborative">
        <div *ngFor="let option of signOptions" class="sign-option-wrapper">
          <div
            class="sign-option"
            [ngClass]="
              selectedOption?.id === option.id
                ? 'selected-option'
                : 'unselected-option'
            "
          >
            <div class="selectable" (click)="trySelectSign(option)">
              <div class="upper-space option-text center stock-amount-text">
                <div class="horizontal-center">
                  <ng-container *ngIf="!option.withoutStock; else noStockTitle">
                    <div>
                      <span class="strong" [ngClass]="option.amountStockClass"
                        >{{
                          option.totalStock == null ? '0' : option.totalStock
                        }}
                      </span>
                      borden in voorraad
                    </div>
                    <div
                      *ngIf="
                        (option.inProductionStock != null &&
                          option.inProductionStock > 0) ||
                        (option.inOfferStock != null &&
                          option.inOfferStock > 0) ||
                        (option.orderedAmount != null &&
                          option.orderedAmount > 0) ||
                        (option.inDirectOrderStock != null &&
                          option.inDirectOrderStock > 0)
                      "
                      class="option-text center"
                    >
                      <div>
                        &

                        <ng-container
                          *ngIf="
                            option.inProductionStock != null &&
                            option.inProductionStock > 0
                          "
                        >
                          <span class="strong">{{
                            option.inProductionStock
                          }}</span>
                          in productie
                        </ng-container>
                        <ng-container
                          *ngIf="
                            option.inProductionStock != null &&
                            option.inProductionStock > 0 &&
                            ((option.inOfferStock != null &&
                              option.inOfferStock > 0) ||
                              (option.orderedAmount != null &&
                                option.orderedAmount > 0))
                          "
                        >
                          &
                        </ng-container>
                        <ng-container
                          *ngIf="
                            (option.inOfferStock != null &&
                              option.inOfferStock > 0) ||
                            (option.orderedAmount != null &&
                              option.orderedAmount > 0)
                          "
                        >
                          <span class="strong">{{
                            option.orderedAmount != null &&
                            option.orderedAmount > 0
                              ? option.orderedAmount
                              : option.inOfferStock
                          }}</span>
                          in offerte
                        </ng-container>

                        <ng-container
                          *ngIf="
                            option.inDirectOrderStock != null &&
                            option.inDirectOrderStock > 0
                          "
                        >
                          &amp;
                          <span class="strong">{{
                            option.inDirectOrderStock
                          }}</span>
                          in bestelling
                        </ng-container>
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #noStockTitle>
                    <div>Zonder voorraad</div>
                  </ng-template>
                </div>
              </div>
              <div class="upper-space sign-example-container">
                <div
                  class="sign-example"
                  [ngStyle]="
                    option.displayExampleStyle != null
                      ? option.displayExampleStyle
                      : {}
                  "
                ></div>
              </div>
              <div class="adjustment-text horizontal-center upper-space">
                (Titel en telefoonnummer zijn aanpasbaar)
              </div>
            </div>
            <hr />
            <div class="option-label sign-option-label-margin">
              <span
                >{{
                  option.signMeasurements?.width
                    | stockSignMeasurements
                      : option.signMeasurements?.height
                      : option.shape?.value ===
                          SIGN_SHAPE_TYPE_CHOICES.UPRIGHT.value
                      : true
                      : false
                      : true
                }}
                -
              </span>
              <span class="strong">{{ option.title }}</span>
              <span class="preserve-span-space">
                - {{ option.phoneNumber }}</span
              >
            </div>
          </div>
          <div class="order-stock-wrapper">
            <button
              mat-button
              class="order-stock-button"
              (click)="openOrderStockDialog(option)"
              *ngIf="!option.withoutStock"
            >
              + Nieuwe voorraad bestellen
            </button>
          </div>
        </div>
        <div class="sign-option-wrapper">
          <!-- custom sign -->
          <div
            class="sign-option"
            [ngClass]="
              selectedOption?.id === -1
                ? 'selected-option'
                : 'unselected-option'
            "
          >
            <div class="selectable" (click)="setCustomSign()">
              <div class="upper-space custom-sign-text bold-text">
                <!-- TODO: check if needs 2 be changed 4 boards without stock -->
                <div class="custom-sign-text-line">Heeft u geen voorraad</div>
                <div class="custom-sign-text-line">klik hier!</div>
              </div>
              <div class="sign-example-container custom-sign-whitespace">
                <div class="align-to-bottom">
                  <div
                    class="custom-sign-example"
                    [ngStyle]="customSignLeftDisplayExample"
                  ></div>
                </div>
                <div class="align-to-bottom left-fifteen-space">
                  <div
                    class="custom-adhesive-sign-example"
                    [ngStyle]="customSignRightDisplayExample"
                  ></div>
                </div>
              </div>
              <div class="upper-space custom-sign-text">
                <div class="custom-sign-text-line strong">
                  ander formaat / ander type
                </div>
                <div class="custom-sign-text-line design-line">
                  (Er wordt eerst een ontwerp opgemaakt)
                </div>
              </div>
            </div>
            <hr />
            <div class="option-label sign-option-label-margin">
              Zonder voorraad / ander type / kleiner formaat
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="project.collaborative">
        <div
          *ngIf="
            !isRightBoard ||
            (leftBoardMeasurement?.width === 100 &&
              leftBoardMeasurement?.height === 140) ||
            (leftBoardMeasurement?.width === 140 &&
              leftBoardMeasurement?.height === 100)
          "
          class="sign-option-wrapper"
          [ngClass]="
            selectedOption?.id === -2
              ? 'selected-recommended-option'
              : 'unselected-recommended-option'
          "
        >
          <div
            class="recommended-label-container"
            [ngClass]="
              selectedOption?.id === -2
                ? 'selected-recommended-option-border'
                : 'unselected-recommended-option-border'
            "
          >
            <div class="recommended-label">Aanbevolen</div>
          </div>
          <div
            class="collaborative-recommended-sign-option selectable"
            (click)="setRecommendedCollaborativeSign()"
          >
            <div class="upper-space custom-sign-text">
              <div class="custom-sign-text-line strong">
                Gezamenlijke opdracht
              </div>
              <div class="custom-sign-text-line">(standaard formaat)</div>
              <div class="custom-sign-text-line">100x140 cm</div>
            </div>
            <div class="sign-example-container">
              <div
                class="sign-example"
                [ngStyle]="
                  customRecommendedCollaborativeOption.displayExampleStyle
                "
              ></div>
            </div>
            <div class="adjustment-text horizontal-center">
              (Er wordt altijd eerst een ontwerp opgemaakt)
            </div>
            <hr />
            <div
              class="option-label"
              [ngClass]="
                selectedOption?.id !== -2
                  ? 'unselected-recommended-sign-option-label-margin'
                  : 'sign-option-label-margin'
              "
            >
              100 x 140 cm - Gezamenlijke opdracht
            </div>
          </div>
        </div>
        <div class="align-with-recommended-label">
          <div class="sign-option-wrapper">
            <div
              class="collaborative-alternative-sign-option selectable"
              [ngClass]="
                selectedOption?.id === -3
                  ? 'selected-option'
                  : 'unselected-option'
              "
              (click)="setAlternativeCollaborativeSign()"
            >
              <div class="upper-space custom-sign-text">
                <div class="custom-sign-text-line strong">
                  Gezamenlijke opdracht
                </div>
                <div class="custom-sign-text-line">
                  (kleiner formaat of ander type)
                </div>
              </div>
              <div
                class="sign-example-container collaborative-alternative-whitespace"
              >
                <div class="upper-space custom-sign-text">
                  <div class="custom-sign-text-line">IP 70x100</div>
                  <div class="custom-sign-text-line">of</div>
                  <div *ngIf="!leftRightBoard" class="custom-sign-text-line">
                    Kleefbord
                  </div>
                  <div *ngIf="leftRightBoard" class="custom-sign-text-line">
                    Andere afmetingen
                  </div>
                </div>
              </div>
              <hr />
              <div class="option-label sign-option-label-margin">
                <span class="strong">Ander formaat</span> - Gezamenlijke
                opdracht
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
